import React from "react";
import { Button, DialogActions, DialogContent } from "@material-ui/core";
import withIntl from "../../utils/withIntl";
import { useDialog } from "./DialogProvider";
import SelectArticles from "../Forms/SelectArticles";

function SelectArticlesDialog(props) {
  const [article, setArticle] = React.useState(props.value);
  const [, closeDialog] = useDialog();

  return (
    <>
      <DialogContent>
        <SelectArticles
          filteredOutArticles={props.filteredOutArticles}
          articleId={article?.id}
          handleOnSelect={setArticle}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={() => props.handleAdd(article.id).then((res) => closeDialog())}>
          {props.intl.formatMessage({ id: "add" })}
        </Button>
      </DialogActions>
    </>
  );
}

export default withIntl(SelectArticlesDialog);
